import { BitrixVue, compile, h } from 'ui.vue3';
import { vplSiteStore } from '../../store/vplstore';
import { mapState } from 'ui.vue3.pinia';

import { VplRouter } from '../../services/vpl-router/vpl-router';

import { TopMenu } from '../menu/topmenu';
import { FixedMenu } from '../menu/fixedmenu';
import { FavoriteMenu } from '../menu/favoritemenu';
import { CompareMenu } from '../menu/comparemenu';
import { HeaderPersonalMenu } from '../menu/headerpersonalmenu';
import { HeaderFixedPersonalMenu } from '../menu/headerfixedpersonalmenu';
import { HeaderSecondMenu } from '../menu/headersecondmenu';
import { HeaderCatalogMenu } from '../menu/headercatalogmenu';

import { PhoneHeader } from '../links/phoneheader';
import { PhoneHeaderMobileIcon } from '../links/phoneheadermobileicon';
import { WhatsappHeader } from '../links/whatsappheader';

import { HeaderBasket } from '../basket/headerbasket';
import { HeaderFixedBasket } from '../basket/headerfixedbasket';
// Выбор города скрыт (решение заказчика 2026-09-17, worklog W-96): компонент не импортируется —
// не попадает в бандл и не отправляет запрос определения города /ajax/location_detect.php.
// import { CityHeader } from './cityheader';


import { SearchTrigger } from '../search/search-trigger';
import { SearchPanelHost } from '../search/search-host';
import { preloadSearchPanel, openSearch } from '../search/search-state';
import { MobileMenuHost } from '../mobile-menu/mobile-menu-host';
import { openMobileMenu, preloadMobileMenu, mobileMenuState } from '../mobile-menu/mobile-menu-state';

import { clearSearch, closeHeaderCatalog, clearHeaderMenuDropdown, showCatalogMenu } from '../../tools/functions';

export const Header = {
  components: {
    TopMenu,
    FixedMenu,
    FavoriteMenu,
    CompareMenu,
    HeaderPersonalMenu,
    HeaderSecondMenu,
    HeaderCatalogMenu,
    HeaderFixedPersonalMenu,
    SearchTrigger,
    SearchPanelHost,
    MobileMenuHost,
    PhoneHeader,
    PhoneHeaderMobileIcon,
    WhatsappHeader,
    HeaderBasket,
    HeaderFixedBasket
  },
  computed: {
    ...mapState(vplSiteStore, ['url', 'SITE_TEMPLATE_PATH']),
    mobileMenuPending() { return mobileMenuState.pending; }
  },
  beforeCreate() {
    //первоначальное получение данных приложения
   // VplRouter(window.location.href);
   	const store = vplSiteStore();

    const data = window.__INITIAL_STATE__;

    store.menu = data.menu;
    store.compare = data.compare;
    store.favorite = data.favorite;
    store.form = data.form;
    store.rekey = data.rekey;
    store.templateData = (data.templateData ? data.templateData : []);
    store.struct = (data.struct ? data.struct : []);
    store.basket = data.basket;
    store.title = data.title;
    store.h1 = data.h1;
    store.SITE_TEMPLATE_PATH = data.SITE_TEMPLATE_PATH;
    store.YA_CLIENT_KEY = data.YA_CLIENT_KEY;
    store.IS_DEALER = data.IS_DEALER;
    store.IS_AUTHORIZED = data.IS_AUTHORIZED
    store.type = 'json';
    store.url = data.url;
    store.edit = data.edit;
    store.fastview = {};
    store.RESPONSE_CODE = data.RESPONSE_CODE;
    store.REQUEST_URL = data.url;
  },
  methods: {
    showCatalogMenu: showCatalogMenu,
    isMainPage() {
      if (this.url !== '/') {
        return false;
      } else {
        return true;
      }
    },
    /**
     * Иконка поиска в мобильной шапке открывает панель выпадающего поиска сразу
     * (правка заказчика 2026-09-18): прежде она раскрывала поле-плейсхолдер
     * (класс is-show на .js-header-search-mob), и панель открывалась только
     * вторым касанием — по фокусу в этом поле.
     */
    searchMobileOpen() {
      closeHeaderCatalog();
      clearHeaderMenuDropdown();
      openSearch('', 'mobile-icon');
    },
    /** касание иконки начинает загрузку группы до отпускания пальца (наведения на мобильных нет) */
    searchMobilePreload() {
      preloadSearchPanel().catch(() => { /* повторится при открытии */ });
    },
    menuPreload() {
      if (window.innerWidth < 991) {
        preloadMobileMenu().catch(() => { /* повторится при открытии */ });
      }
    },
    burgerClick(event) {

      if (window.innerWidth < 991) {
        clearSearch();
        closeHeaderCatalog();
        openMobileMenu('root', event.currentTarget);
        return;
      }

      clearSearch();
      clearHeaderMenuDropdown();
      $('.js-catalog').removeClass('is-active');
      $('.js-panel').removeClass('is-active');
      $('.js-header').find('.js-catalog-dropdown').removeClass('is-open');
      $('body').removeClass('dropdown-open');
      $('body').removeClass('search-open');
      $('.js-header-search-mob').removeClass('is-show');
      $('.js-fixed-search').removeClass('is-active');
      $('.js-overlay').removeClass('is-show');
      let burger = $(event.target);
      if (!burger.hasClass('is-active')) {
        burger.addClass('is-active');
        burger.removeClass('is-static');
        burger.closest('.js-burger-wp').find('.js-burger-dropdown').addClass('is-open');
        $('body').addClass('dropdown-open'); // $('.js-overlay').addClass('is-show');
      } else {
        closeHeaderCatalog();
      }

    },
    closeSearch() {
      clearSearch();
      closeHeaderCatalog();
      $('body').removeClass('dropdown-open');
      $('body').removeClass('search-open');
    }

  },
  mounted() {

    function fixedHeader() {
      if ($(window).scrollTop() > $('.js-header').height() && $(window).width() > 992) {
        $('body').addClass("is-fixed");
      } else {
        $('body').removeClass("is-fixed");
      }

      if ($(window).scrollTop() > $('.js-header').height() && $(window).width() < 991) { }
    }


    $('body').on('click', '.js-reauth', function (e) {
      e.preventDefault();
      $('#registration').modal('hide');
      $('#entrance').modal();
    });

    fixedHeader();
    window.addEventListener("scroll", function () {
      fixedHeader();
    }, {
      passive: true
    });

    // Обработчик .js-fixed-search на jQuery удалён (2026-09-18): он висел на той же
    // иконке, что и @click в шаблоне, и раскрывал поле-плейсхолдер — теперь иконка
    // открывает панель поиска (методы searchMobileOpen/searchMobilePreload).
    /*


    $('body').on('click', '.js-header-catalog-btn', function (e) {
      e.preventDefault();
      //clearSearch();

      if (!$(this).hasClass('is-active')) {
        $(this).addClass('is-active');
        $(this).removeClass('is-static');
        $('.js-header').find('.js-header-catalog').addClass('is-open');
        $('body').addClass('catalog-open');
        $('.js-overlay').addClass('is-show');
        $('.js-panel').addClass('is-hide');
      } else {
        closeHeaderCatalog();
        $('.js-panel').removeClass('is-hide');
      }
    });

    $('body').on('click', '.header__catalog-list-link', function () {
      setTimeout(() => {
        $('.js-panel').removeClass('is-hide');
      }, 1000)
    });

    //обновление избранного
    BX.addCustomEvent('RefreshFavorite', () => {
      $.ajax({
          url: '/ajax/favorite.php',
          method: 'POST',
          data: {get_items: 'Y'},
          success: (response) => {
              try {
                  const favoriteData = JSON.parse(response);
                  const store = vplSiteStore();
                  store.favorite = favoriteData;
              }catch(err){ }
          }
      });
    });
    */

  },
  template: `
      <div class="header__top">
        <div class="container">
          <div class="header__top-wp">
            <TopMenu />
          </div>
        </div>
      </div>
      <div class="header__middle">
        <div class="container">
          <div class="header__middle-wp">
            <a href="#" class="burger js-burger" :class="{ 'is-pending': mobileMenuPending }"
                 :aria-busy="mobileMenuPending" @click.prevent="burgerClick($event)"
                 @touchstart.passive="menuPreload()" @pointerenter="menuPreload()">
              <span></span>
              <span></span>
              <span></span>
            </a>
            <a href="#" class="header__search-mob js-fixed-search" @click.prevent="searchMobileOpen()"
               @touchstart.passive="searchMobilePreload()" @pointerenter="searchMobilePreload()">
              <svg class="icon icon-search"><use xlink:href="#icon-search"></use></svg>
            </a>
            <a v-if="isMainPage() === false" href="/" class="header__logo">
              <img src="/local/templates/vpl_vue/img/svg/logo.svg" alt="TAS.pro" title="TAS.pro">
            </a>
            <a v-if="isMainPage() === true" href="/" class="header__logo">
              <img src="/local/templates/vpl_vue/img/svg/logo.svg" alt="TAS.pro" title="TAS.pro">
            </a>
            <!-- <CityHeader /> — выбор города скрыт, W-96 -->
            <SearchTrigger variant="header" />
            <div class="header__middle-contacts">
              <div class="contacts-block">
                <PhoneHeader />
                <a href="#" data-toggle="modal" data-target="#callback" class="contacts-block__link">Заказать звонок</a>
              </div>
              <WhatsappHeader />
            </div>
            <div class="header__top-actions">
              <FavoriteMenu />
              <CompareMenu />
              <HeaderBasket />
              <HeaderPersonalMenu />
            </div>

            <PhoneHeaderMobileIcon />
          </div>
        </div>
      </div>
      <div class="header__bottom">
        <div class="container">
          <HeaderSecondMenu />
        </div>
      </div>
      <HeaderCatalogMenu />
      <div class="header__fixed">
        <div class="container">
          <div class="header__fixed-wp">
            <div class="burger__wp js-burger-wp">
              <a href="#" class="burger js-burger" :class="{ 'is-pending': mobileMenuPending }"
                 :aria-busy="mobileMenuPending" @click.prevent="burgerClick($event)"
                 @touchstart.passive="menuPreload()" @pointerenter="menuPreload()">
                <span></span>
                <span></span>
                <span></span>
              </a>
              <div class="burger__dropdown js-burger-dropdown">
                <FixedMenu />
              </div>
            </div>

            <a v-if="isMainPage() === false" href="/" class="header__fixed-logo">
              <img src="/local/templates/vpl_vue/img/svg/logo.svg" alt="TAS.pro" title="TAS.pro">
            </a>
            <a v-else href="/" class="header__fixed-logo">
              <img src="/local/templates/vpl_vue/img/svg/logo.svg" alt="TAS.pro" title="TAS.pro">
            </a>



            <HeaderSecondMenu fixed="Y" />
            <!-- <CityHeader /> — выбор города скрыт, W-96 -->
            <SearchTrigger variant="header" />
            <div class="header__middle-contacts">
              <div class="contacts-block">
                <PhoneHeader />
                <a href="#" data-toggle="modal" data-target="#callback" class="contacts-block__link">Заказать звонок</a>
              </div>
              <WhatsappHeader />
            </div>
            <div class="header__top-actions">
              <FavoriteMenu />
              <CompareMenu />
              <HeaderBasket />
              <HeaderPersonalMenu />
            </div>
          </div>
        </div>
      </div>



      <div class="header__search-overlay js-header-search-catalog-overlay" @click="closeSearch();"></div>
      <SearchPanelHost />
      <MobileMenuHost />
    `
}
